import React from "react"
import { DropdownMenuProps } from "../types"

const DropdownMenu: React.FC<DropdownMenuProps> = ({
  options,
  selectedValues,
  onSelect,
  searchValue,
  focusedIndex,
  isOpen,
}) => {
  // 検索フィルタリング
  const filteredOptions = React.useMemo(() => {
    if (!searchValue) return options

    return options.filter(
      (option) =>
        option.label.toLowerCase().includes(searchValue.toLowerCase()) ||
        option.value.toLowerCase().includes(searchValue.toLowerCase())
    )
  }, [options, searchValue])

  const isSelected = (value: string) => selectedValues.includes(value)

  const handleOptionClick = (e: React.MouseEvent, value: string) => {
    e.preventDefault()
    e.stopPropagation()
    onSelect(value)
  }

  if (!isOpen) return null

  return (
    <div className="absolute z-50 w-full mt-1 bg-white border border-medium-light-gray rounded-md shadow-lg max-h-96 overflow-auto">
      {filteredOptions.length === 0 ? (
        <div className="px-3 py-2 text-smooth-black text-opacity-60 text-[1.4rem]">
          {searchValue ? "検索結果が見つかりません" : "オプションがありません"}
        </div>
      ) : (
        filteredOptions.map((option, index) => {
          const selected = isSelected(option.value)
          const focused = index === focusedIndex

          return (
            <div
              key={option.value}
              className={`px-3 py-2 cursor-pointer text-[1.4rem] transition-colors duration-150 ${
                option.disabled
                  ? "opacity-50 cursor-not-allowed"
                  : focused
                  ? "bg-smooth-blue bg-opacity-10 text-smooth-blue"
                  : selected
                  ? "bg-smooth-blue bg-opacity-5 text-white"
                  : "text-smooth-black hover:bg-gray-50"
              }`}
              onClick={(e) => !option.disabled && handleOptionClick(e, option.value)}
              role="option"
              aria-selected={selected}
              aria-disabled={option.disabled}
            >
              <div className="flex items-center justify-between">
                <span className="truncate">{option.label}</span>
                {selected && (
                  <svg
                    className="w-4 h-4 text-smooth-blue ml-2"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                )}
              </div>
            </div>
          )
        })
      )}
    </div>
  )
}

export default DropdownMenu
